import { render, staticRenderFns } from "./05xinhengdianshang.vue?vue&type=template&id=276d5fc1&scoped=true&"
import script from "./05xinhengdianshang.vue?vue&type=script&lang=js&"
export * from "./05xinhengdianshang.vue?vue&type=script&lang=js&"
import style0 from "./05xinhengdianshang.vue?vue&type=style&index=0&id=276d5fc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276d5fc1",
  null
  
)

export default component.exports